import { useEffect } from "react";
import {
  requestNotificationPermission,
  listenForMessages,
} from "../firebase/messaging";
import { saveUserToken } from "../services/notificationService";
import collapsedLogo from "../assets/images/simple_logo.png";

export default function NotificationListener({ currentUser }) {
  useEffect(() => {
    if (!currentUser?.uuid) return;

    // Ask for permission + save token in Firestore
    requestNotificationPermission().then((token) => {
      if (token) {
        saveUserToken(currentUser, token);
      }
    });

    // Listen for foreground messages
    const unsubscribe = listenForMessages((payload) => {
      console.log("Foreground notification:", payload);

      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: collapsedLogo,
      });
    });

    return () => unsubscribe();
  }, [currentUser]);

  return null; // nothing to render
}
